import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  SecurityContext,
  inject,
  viewChild,
  ChangeDetectionStrategy,
} from "@angular/core";

import { ModalAbstractComponent } from "../modal-abstract.component";
import { DomSanitizer } from "@angular/platform-browser";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Dialog } from "primeng/dialog";
import { InputText } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, Bind, Dialog, FormsModule, InputText],
})
export class ConfirmComponent
  extends ModalAbstractComponent<void>
  implements OnInit, AfterViewInit
{
  private sanitizer = inject(DomSanitizer);

  public message: string;
  public title: string;
  public readonly confirmButton = viewChild<ElementRef>("confirmButton");
  public readonly denyButton = viewChild<ElementRef>("denyButton");
  public showDeleteInput: boolean = false;
  public destructive: boolean = false;
  public confirmLabel: string | null = null;
  public denyLabel: string | null = null;
  public deleteText: string;
  private lastActiveElement: HTMLElement;

  ngOnInit() {
    this.lastActiveElement = document.activeElement as HTMLElement;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.denyButton().nativeElement.focus();
    }, 0);
  }

  public setMessage(message: string): void {
    this.message = this.sanitizer.sanitize(SecurityContext.HTML, message);
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public setShowDeleteInput(showDeleteInput: boolean): void {
    this.showDeleteInput = showDeleteInput;
  }

  public setDestructive(destructive: boolean): void {
    this.destructive = destructive;
  }

  public setLabels(confirmLabel?: string, denyLabel?: string): void {
    this.confirmLabel = confirmLabel ?? null;
    this.denyLabel = denyLabel ?? null;
  }

  public close() {
    super.close();

    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }
}
